import React from 'react';
import PropTypes from 'prop-types';

import { Section, SectionHeader, SectionTitle, SectionDescription } from './FormSection.styled';

/**
 * One group of a long form: a titled card holding the questions that belong
 * together.
 *
 * Long approval forms - the Young Crew yearly report, the meeting application -
 * are built out of these, so a reader coming from one recognises the other.
 */
function FormSection({ title, description, children }) {
  return (
    <Section>
      {title ? (
        <SectionHeader>
          <SectionTitle>{title}</SectionTitle>
          {description ? <SectionDescription>{description}</SectionDescription> : null}
        </SectionHeader>
      ) : null}
      {children}
    </Section>
  );
}

FormSection.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node,
};

FormSection.defaultProps = {
  title: null,
  description: null,
  children: null,
};

export default FormSection;
